import React from "react"
import SidePanelLayout from "aldoo-ra/SidePanel"
import AgentBrowser from "./AgentBrowser"
import SessionBrowser from "./SessionBrowser"
import UsageBrowser from "./UsageBrowser"
import NeedsBrowser from "./NeedsBrowser"
import VisitorBrowser from "./VisitorBrowser"

const AgentsAdmin = () => {
  const tabResolver = (defaultTab, context, pathname) => {
    if (pathname.includes("/admin/agents/sessions"))  return "sessions"
    if (pathname.includes("/admin/agents/usages"))    return "usages"
    if (pathname.includes("/admin/agents/needs"))     return "needs"
    if (pathname.includes("/admin/agents/visitors"))  return "visitors"
    return "agents"
  }

  return (
    <SidePanelLayout
      menuName="AdminAgentsMenu"
      tabs={{
        agents:   AgentBrowser,
        sessions: SessionBrowser,
        usages:   UsageBrowser,
        needs:    NeedsBrowser,
        visitors: VisitorBrowser,
      }}
      tabResolver={tabResolver}
    />
  )
}

export default AgentsAdmin
